/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    CreateUserGroupData,
    DeleteUserGroupsBody,
    GetUserGroupsParams,
    UpdateUserGroupBody,
    UserGroupId,
    UserGroupListResponse,
    UserGroupViewDto,
    UserGroupsDeletionFailedDetails,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getUserGroupsGroupId = (
    groupId: UserGroupId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserGroupViewDto>> => {
    return axios.get(`/api/user-groups/${groupId}`, options);
};

export const getGetUserGroupsGroupIdQueryKey = (groupId: UserGroupId) => {
    return [`/api/user-groups/${groupId}`] as const;
};

export const getGetUserGroupsGroupIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserGroupsGroupIdQueryKey(groupId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserGroupsGroupId>>
    > = ({ signal }) =>
        getUserGroupsGroupId(groupId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: groupId !== null && groupId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserGroupsGroupId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserGroupsGroupIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserGroupsGroupId>>
>;
export type GetUserGroupsGroupIdQueryError = AxiosError<unknown>;

export function useGetUserGroupsGroupId<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                    TError,
                    Awaited<ReturnType<typeof getUserGroupsGroupId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsGroupId<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                    TError,
                    Awaited<ReturnType<typeof getUserGroupsGroupId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsGroupId<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserGroupsGroupId<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserGroupsGroupIdQueryOptions(groupId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserGroupsGroupIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserGroupsGroupIdQueryKey(groupId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserGroupsGroupId>>
    > = ({ signal }) =>
        getUserGroupsGroupId(groupId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserGroupsGroupId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserGroupsGroupIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserGroupsGroupId>>
>;
export type GetUserGroupsGroupIdSuspenseQueryError = AxiosError<unknown>;

export function useGetUserGroupsGroupIdSuspense<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsGroupIdSuspense<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsGroupIdSuspense<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserGroupsGroupIdSuspense<
    TData = Awaited<ReturnType<typeof getUserGroupsGroupId>>,
    TError = AxiosError<unknown>,
>(
    groupId: UserGroupId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroupsGroupId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserGroupsGroupIdSuspenseQueryOptions(
        groupId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUserGroupsGroupId = (
    groupId: UserGroupId,
    updateUserGroupBody: UpdateUserGroupBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserGroupViewDto>> => {
    return axios.patch(
        `/api/user-groups/${groupId}`,
        updateUserGroupBody,
        options
    );
};

export const getPatchUserGroupsGroupIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUserGroupsGroupId>>,
        TError,
        { groupId: UserGroupId; data: UpdateUserGroupBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUserGroupsGroupId>>,
    TError,
    { groupId: UserGroupId; data: UpdateUserGroupBody },
    TContext
> => {
    const mutationKey = ["patchUserGroupsGroupId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUserGroupsGroupId>>,
        { groupId: UserGroupId; data: UpdateUserGroupBody }
    > = (props) => {
        const { groupId, data } = props ?? {};

        return patchUserGroupsGroupId(groupId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUserGroupsGroupIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUserGroupsGroupId>>
>;
export type PatchUserGroupsGroupIdMutationBody = UpdateUserGroupBody;
export type PatchUserGroupsGroupIdMutationError = AxiosError<unknown>;

export const usePatchUserGroupsGroupId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUserGroupsGroupId>>,
            TError,
            { groupId: UserGroupId; data: UpdateUserGroupBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUserGroupsGroupId>>,
    TError,
    { groupId: UserGroupId; data: UpdateUserGroupBody },
    TContext
> => {
    return useMutation(
        getPatchUserGroupsGroupIdMutationOptions(options),
        queryClient
    );
};
export const getUserGroups = (
    params?: GetUserGroupsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserGroupListResponse>> => {
    return axios.get(`/api/user-groups`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUserGroupsQueryKey = (params?: GetUserGroupsParams) => {
    return [`/api/user-groups`, ...(params ? [params] : [])] as const;
};

export const getGetUserGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({
        signal,
    }) => getUserGroups(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserGroups>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserGroupsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserGroups>>
>;
export type GetUserGroupsQueryError = AxiosError<unknown>;

export function useGetUserGroups<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetUserGroupsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserGroups>>,
                    TError,
                    Awaited<ReturnType<typeof getUserGroups>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroups<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserGroups>>,
                    TError,
                    Awaited<ReturnType<typeof getUserGroups>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroups<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserGroups<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserGroupsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserGroupsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({
        signal,
    }) => getUserGroups(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserGroups>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserGroupsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserGroups>>
>;
export type GetUserGroupsSuspenseQueryError = AxiosError<unknown>;

export function useGetUserGroupsSuspense<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetUserGroupsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsSuspense<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserGroupsSuspense<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserGroupsSuspense<
    TData = Awaited<ReturnType<typeof getUserGroups>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUserGroupsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserGroups>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserGroupsSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postUserGroups = (
    createUserGroupData: CreateUserGroupData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserGroupViewDto>> => {
    return axios.post(`/api/user-groups`, createUserGroupData, options);
};

export const getPostUserGroupsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postUserGroups>>,
        TError,
        { data: CreateUserGroupData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postUserGroups>>,
    TError,
    { data: CreateUserGroupData },
    TContext
> => {
    const mutationKey = ["postUserGroups"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postUserGroups>>,
        { data: CreateUserGroupData }
    > = (props) => {
        const { data } = props ?? {};

        return postUserGroups(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostUserGroupsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postUserGroups>>
>;
export type PostUserGroupsMutationBody = CreateUserGroupData;
export type PostUserGroupsMutationError = AxiosError<unknown>;

export const usePostUserGroups = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postUserGroups>>,
            TError,
            { data: CreateUserGroupData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postUserGroups>>,
    TError,
    { data: CreateUserGroupData },
    TContext
> => {
    return useMutation(getPostUserGroupsMutationOptions(options), queryClient);
};
export const deleteUserGroups = (
    deleteUserGroupsBody: DeleteUserGroupsBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/user-groups`, {
        data: deleteUserGroupsBody,
        ...options,
    });
};

export const getDeleteUserGroupsMutationOptions = <
    TError = AxiosError<UserGroupsDeletionFailedDetails>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUserGroups>>,
        TError,
        { data: DeleteUserGroupsBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserGroups>>,
    TError,
    { data: DeleteUserGroupsBody },
    TContext
> => {
    const mutationKey = ["deleteUserGroups"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteUserGroups>>,
        { data: DeleteUserGroupsBody }
    > = (props) => {
        const { data } = props ?? {};

        return deleteUserGroups(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteUserGroupsMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteUserGroups>>
>;
export type DeleteUserGroupsMutationBody = DeleteUserGroupsBody;
export type DeleteUserGroupsMutationError =
    AxiosError<UserGroupsDeletionFailedDetails>;

export const useDeleteUserGroups = <
    TError = AxiosError<UserGroupsDeletionFailedDetails>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteUserGroups>>,
            TError,
            { data: DeleteUserGroupsBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteUserGroups>>,
    TError,
    { data: DeleteUserGroupsBody },
    TContext
> => {
    return useMutation(
        getDeleteUserGroupsMutationOptions(options),
        queryClient
    );
};
